import React from 'react';
import './diagrams.css';

/* Case 02 — the "instant update" mechanism. Two lanes (FAST admin /
   consumer app) and a single accent crossing: the change goes live with
   no deploy. The crossing IS the concept, so it carries the accent. */

export default function InstantUpdate() {
  return (
    <figure className="ppd">
      <div className="ppd__head">
        <h3 className="ppd__title">A change in FAST is live before you close the tab.</h3>
        <span className="ppd__tag">No deploy</span>
      </div>

      <div className="ppd__lanes">
        <div className="ppd__lane">
          <span className="ppd__lane-label">FAST · admin</span>
          <span className="ppd__lane-body">
            A non-engineer hides a feel, swaps a backdrop, reorders a collection, or edits clip
            timing to the millisecond.
          </span>
        </div>

        <div className="ppd__cross" aria-hidden="true">
          <span className="ppd__cross-line">instant · scoped by role · reversible</span>
        </div>

        <div className="ppd__lane">
          <span className="ppd__lane-label">Consumer app</span>
          <span className="ppd__lane-body">
            What every fan sees updates immediately — no ticket, no release, no engineer in the loop.
          </span>
        </div>
      </div>

      <figcaption className="ppd__caption">
        Immediate power over a live, licensed surface means the <b>safety has to live in the design</b> —
        clear states, reversibility, and permissions — because there's no deploy step to catch a mistake.
      </figcaption>
    </figure>
  );
}
